export default __webpack_public_path__ + "static/media/arrow-path-icon.4445bc02.svg";